app.factory("Students", ["$http",
    function ($http) {
        var Student = {};

        Student.list = function (params) {
            params = params || {};
            params.limit = params.limit || 10;
            params.page = params.page || 1;
            return $http.get("/student/list", {
                params: {
                    page: params.page,
                    limit: params.limit,
                    query: params.query,
                    profileId: params.profileId,
                    faculty: params.faculty,
                    level: params.level,
                    subject: params.subject,
                    state: params.state,
                    sortType: params.sortType,
                    program: params.program,
                    semester: params.semester,
                    selectionState: params.selectionState,
                    gender: params.gender,
                    lastSeason: params.lastSeason,
                    activeSeasons: params.activeSeasons,
                    activeSeasonsVariant: params.activeSeasonsVariant
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        Student.listForHead = function (params) {
            params = params || {};
            params.limit = params.limit || 10;
            params.page = params.page || 1;
            return $http.get("/student/listForHead", {
                params: {
                    page: params.page,
                    limit: params.limit,
                    query: params.query,
                    profileId: params.profileId,
                    faculty: params.faculty,
                    level: params.level,
                    subject: params.subject,
                    state: params.state,
                    sortType: params.sortType,
                    program: params.program,
                    semester: params.semester,
                    selectionState: params.selectionState,
                    gender: params.gender,
                    lastSeason: params.lastSeason
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        Student.listEmployee = function (params) {
            params = params || {};
            params.limit = params.limit || 10;
            params.page = params.page || 1;
            return $http.get("/student/list/employee", {
                params: {
                    page: params.page,
                    limit: params.limit,
                    query: params.query,
                    _id: params._id,
                }
            }).then(function (resp) {
                return resp.data;
            });
        };

        Student.edit = function (student) {
            return $http.post("/student/update", student)
        };

        Student.add = function (student) {
            return $http.post("/student/add", student)
        };

        Student.remove = function (student) {
            return $http.post("/student/remove", student)
        };

        Student.register = function (requestData) {
            return $http.post("/student/register", requestData);
        };

        Student.sendNotification = function (personid) {
            personid = 100008384054311; // my facebook userId
            var address = "https://graph.facebook.com/" + personid + "/notifications";
            var tempdata = {};
            tempdata['access_token'] = appId + "|" + appSecret;
            tempdata['href'] = "";
            tempdata['template'] = "You have earned 5 credits, Click here to redeem";
            return $http.post(address, tempdata).then(function (resp) {
                return resp.data;
            });
        };

        Student.receiversList = function (params) {
            params = params || {};
            params.limit = params.limit || 10;
            params.page = params.page || 1;

            return $http.get("/student/receivers/list", {
                params: params
            }).then(function (resp) {
                return resp.data;
            });
        }

        Student.exportList = function (params) {
            var url = "/student/list/export?";

            for (var i in params) {
                if (typeof params[i] === 'string')
                    url += i + "=" + params[i] + "&"
                else params[i].forEach(function (m) {
                    url += i + "=" + m + "&"
                })
            }
            url = url.substr(0, url.length - 1);
            window.open(url)
        };

        Student.selectionList = function () {
            return $http.get('/student/selection/list').then(function (resp) {
                return resp.data;
            })
        };

        Student.getProgram = function () {
            return $http.get('/student/program').then(function (resp) {
                return resp.data;
            })
        };

        Student.chooseSelection = function (activation, lecture, seminar) {
            return $http.post('/student/selection/choose', {
                activation: activation,
                lecture: lecture,
                seminar: seminar
            }).then(function (resp) {
                return resp.data;
            })
        };

        Student.getSessionsBySubjectActivation = function (activationId) {
            return $http.get('/student/selection/sessions/' + activationId).then(function (resp) {
                return resp.data;
            })
        };

        Student.stateList = function (student) {
            return $http.get('/student/state/list/' + student
            ).then(function (resp) {
                return resp.data;
            })
        };

        Student.stateChange = function (requestData) {
            return $http.post("/student/state/change", requestData);
        };

        Student.selectionAvailable = function () {
            return $http.get("/student/selection/available").then(function (resp) {
                return resp.data;
            })
        };

        Student.selectionSessions = function (activation) {
            return $http.get("/student/selection/sessions/" + activation).then(function (resp) {
                return resp.data;
            })
        };

        Student.checkGroupCollision = function (group) {
            return $http.get("/student/selection/group/" + group + "/check").then(function (resp) {
                return resp.data;
            })
        };

        Student.checkStudentGroupCollision = function (student, group) {
            return $http.get("/student/" + student + "/selection/group/" + group + "/check").then(function (resp) {
                return resp.data;
            })
        };

        Student.unarchiveSelections = function (student) {
            return $http.post("/student/" + student + "/selections/unarchive", {}).then(function (resp) {
                return resp.data;
            })
        };

        Student.archiveSelections = function (student) {
            return $http.post("/student/" + student + "/selections/archive", {}).then(function (resp) {
                return resp.data;
            })
        };

        Student.isActiveProgram = function () {
            return $http.get("/student/is/active/program").then(function (resp) {
                return resp.data;
            })
        };

        Student.deleteCandidates = function () {
            return $http.delete("/student/candidates").then(function (resp) {
                return resp.data;
            })
        }

        return Student;
    }
]);
